<template>
<layout-content>
  <template #toolbar>
    <span style="font-size:1em;color:#606266;">选择年份：</span>
    <el-select
      v-model="query.years"
      size="small"
      multiple
      collapse-tags
      style="width: 160px;"
      v-default-select="[enterpriseIds]"
      @change="yearsChange"
    >
      <el-option
        v-for="item in earliest"
        :disabled="item.value === Number(new Date().format('YYYY'))"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>

    <el-select v-model="query.siteIds[0]" size="small" style="width: 150px;">
      <el-option
        v-for="item in filterSites"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div style="width: 80%;">
          <span style="font-size:1em;color:#606266">参考年份:</span>
          <el-select
            v-model="reference"
            size="small"
            multiple
            collapse-tags
            placeholder="请选择参考年份"
            style="width: 160px;"
            @change="computedPV"
          >
            <el-option
              v-for="item in referenceOptions"
              :disabled="item.value === Number(new Date().format('YYYY'))"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span style="font-size:1em;color:#606266; margin-left: 10px;">优良/天(目标)：</span>
          <el-input v-model="pvVal" type="number" step="365" max="365" min="0" size="small" style="width: 80px;" @input="computedPV" />
          <h4>空气质量达标预测</h4>
          <el-table
            ref="table"
            :data="pvData"
            border
            size="small"
            title="空气质量达标预测"
            highlight-current-row
            style="width: 850px;margin: 5px auto;"
          >
            <el-table-column label="类别" prop="sort" align="center" />
            <el-table-column v-for="(item, i) in tableHeader" :key="i" :label="item" width="60" align="center" >
              <template slot-scope="{$index, row}">
                <p
                  :style="{
                    'text-align': 'center',
                    'margin': 0,
                    'font-size': '16px',
                    'color': `${(i < currentMonth && $index === 1) ? '#00EE00' : row[i + 'flag']}`
                  }"
                >
                  {{row[i + 'data'] === '' ? '--' : row[i + 'data']}}
                </p>
              </template>
            </el-table-column>
          </el-table>
          <ul class="legend-wrapper">
            <li><section style="background-color:#00EE00"></section><label>当前实际数据</label></li>
            <li><section style="background-color:#FF7E00"></section><label>预测天数可能达标</label></li>
            <li><section style="background-color:#FF0000"></section><label>预测天数已不能达标</label></li>
          </ul>
        </div>
        <!--  'color': `${(pvData[i] > new Date(new Date().format('YYYY'), i + 1, 0).getDate()) ? '#FF0000' : (pvData[i] === '' ? '' : (pvData[i] > (new Date(new Date().format('YYYY'), i + 1, 0).getDate() / 2) ? '#FF7E00' : '#00EE00'))}` -->
        <!-- <el-descriptions class="margin-top" title="空气质量达标预测（年度按月预测/实际按月预测）" direction="vertical" :column="12" size="medium" border>
          <el-descriptions-item v-for="(item, i) in tableHeader" :key="i">
            <template slot="label">
              {{item}}
            </template>
            <p
              :style="{
                'text-align': 'center',
                'margin': 0,
                'font-weight': 'blod',
                'color': `${pvData[i].flag}`
              }"
            >
              {{pvData[i].value === '' ? '--' : pvData[i].value}}
            </p>
          </el-descriptions-item>
        </el-descriptions> -->
      </template>
      <div class="report-data-table-header">
        <span>空气质量历史数据</span>
      </div>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        stripe
        size="small"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column prop="date" label="年份" width="50" fixed />
        <el-table-column prop="goodDays" label="优良/天" fit width="63" fixed >
          <template slot-scope="{$index, row}">
            <el-popover
              trigger="hover"
              popper-class="pollutant-tooltip"
              :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
            >
              <div class="primary-pollutant" >
                <div class="aqi-val">
                  <p>
                    AQI均值：
                    <span>
                      {{row.avgAqi !== '--' && row.avgAqi !== '' ? row.avgAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                  <p>
                    AQI最高值：
                    <span>
                      {{row.maxAqi !== '--' && row.maxAqi !== '' ? row.maxAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                  <p>
                    AQI最低值：
                    <span>
                      {{row.minAqi !== '--' && row.minAqi !== '' ? row.minAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                </div>
              </div>
              <p slot="reference" style="cursor: pointer;">{{row.goodDays ? row.goodDays : '--'}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="badDays" label="污染/天" fit fixed >
          <template slot-scope="{$index, row}">
            <el-popover
              trigger="hover"
              popper-class="pollutant-tooltip"
              :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
            >
              <div class="primary-pollutant" >
                <h3>主要污染物</h3>
                <div class="pollutant">
                  <p v-for="(primary, i) in row.primaryPollutantDays" :key="i">
                    {{primary.primaryPollutant}}： <span>{{primary.days}}(天)</span>
                  </p>
                </div>
                <div class="aqi-val">
                  <p>
                    AQI均值：
                    <span>
                      {{row.avgAqi !== '--' && row.avgAqi !== '' ? row.avgAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                  <p>
                    AQI最高值：
                    <span>
                      {{row.maxAqi !== '--' && row.maxAqi !== '' ? row.maxAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                  <p>
                    AQI最低值：
                    <span>
                      {{row.minAqi !== '--' && row.minAqi !== '' ? row.minAqi.toFixed(3) : '--'}}
                    </span>
                  </p>
                </div>
              </div>
              <p slot="reference" style="cursor: pointer;">{{row.badDays ? row.badDays : '--'}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, i) in tableHeader" :key="i" :label="item" align="center" >
          <el-table-column prop="monthData" label="优良/天" fit width="63" >
            <template slot-scope="{$index, row}">
              <el-popover
                trigger="hover"
                popper-class="pollutant-tooltip"
                :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
              >
                <div class="primary-pollutant" >
                  <div class="aqi-val">
                    <p>
                      AQI均值：
                      <span>
                        {{row.monthData[i].avgAqi !== '--' && row.monthData[i].avgAqi !== '' ? row.monthData[i].avgAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                    <p>
                      AQI最高值：
                      <span>
                        {{row.monthData[i].maxAqi !== '--' && row.monthData[i].maxAqi !== '' ? row.monthData[i].maxAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                    <p>
                      AQI最低值：
                      <span>
                        {{row.monthData[i].minAqi !== '--' && row.monthData[i].minAqi !== '' ? row.monthData[i].minAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                  </div>
                </div>
                <p slot="reference" style="cursor: pointer;">{{row.monthData[i].goodDays === '' ? '--' : row.monthData[i].goodDays}}</p>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="monthData" label="污染/天" fit width="63" >
            <template slot-scope="{$index, row}">
              <el-popover
                trigger="hover"
                popper-class="pollutant-tooltip"
                :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
              >
                <div class="primary-pollutant" >
                  <h3>主要污染物({{item}})</h3>
                  <div class="pollutant">
                    <p v-for="(primary, index) in row.monthData[i].primaryPollutantDays" :key="index">
                      {{primary.primaryPollutant}}： <span>{{primary.days}}(天)</span>
                    </p>
                  </div>
                  <div class="aqi-val">
                    <p>
                      AQI均值：
                      <span>
                        {{row.monthData[i].avgAqi !== '--' && row.monthData[i].avgAqi !== '' ? row.monthData[i].avgAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                    <p>
                      AQI最高值：
                      <span>
                        {{row.monthData[i].maxAqi !== '--' && row.monthData[i].maxAqi !== '' ? row.monthData[i].maxAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                    <p>
                      AQI最低值：
                      <span>
                        {{row.monthData[i].minAqi !== '--' && row.monthData[i].minAqi !== '' ? row.monthData[i].minAqi.toFixed(3) : '--'}}
                      </span>
                    </p>
                  </div>
                </div>
                <p slot="reference" style="cursor: pointer;">{{row.monthData[i].badDays === '' ? '--' : row.monthData[i].badDays}}</p>
              </el-popover>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'StatisticalAnalysisAirQualityAnalysis',
  routeInfo: {
    label: '空气质量达标分析'
  },
  extends: BaseFactorData,
  components: {LayoutContent, DataWrapper},
  data () {
    return {
      query: {
        years: [Number(new Date().format('YYYY')), (new Date().format('YYYY') - 1)],
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        isAuditCompleted: false
      },
      enterpriseIds: [Number(new Date().format('YYYY')), (new Date().format('YYYY') - 1)],
      reference: [],
      referenceOptions: [{
        value: Number(new Date().format('YYYY')),
        label: Number(new Date().format('YYYY'))
      }, {
        value: Number(new Date().format('YYYY')) - 1,
        label: Number(new Date().format('YYYY')) - 1
      }],
      pvVal: '200',
      currentMonth: new Date().getMonth(),
      pvData: [],
      list: []
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    earliest () {
      let result = []
      let start = process.env.Y_O_Y_YEAR
      for (let i = start; i <= Number(new Date().format('YYYY')); i++) {
        result.push({
          value: i,
          label: i
        })
      }
      return result.sort((a, b) => b.value - a.value)
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    },
    // grade状态码
    gradeLevel () {
      return {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
    },
    tableHeader () {
      return ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    yearsChange (val) {
      this.referenceOptions = val.map(el => {
        return {
          value: el,
          label: el
        }
      })
    },
    /**
     * @description 数组转Map
    */
    arrayToMap (data, key) {
      return data.reduce((map, el) => {
        map[el[key]] = el
        return map
      }, {})
    },
    getData () {
      this.changeLoadStatus(true)
      let {query} = this
      if (query.siteIds.length === 0) {
        this.changeLoadStatus(false)
        return
      }

      if (query.years.length < 2) {
        this.$notify.error({
          title: '错误',
          message: '至少选择两个年份',
          position: 'bottom-right'
        })
        this.referenceOptions = [{
          value: new Date().getFullYear(),
          label: new Date().getFullYear()
        }]
        this.reference = []

        this.list = []
        this.changeLoadStatus(false)
        return
      }

      this.$api.Aqi.getContrast(query).then(backData => {
        let dataMap = this.arrayToMap(backData, 'date')
        let data = this.defaultYearData(query.years, query.siteIds[0]).map(el => {
          if (dataMap[el.date]) {
            dataMap[el.date].date = Number(el.date)
            return dataMap[el.date]
          }

          return el
        })

        this.reference = query.years.filter(el => el !== Number(new Date().format('YYYY')))
        this.setTableData(data)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setTableData (data) {
      let routine = {
        'NO2': '',
        'O3': '',
        'PM2.5': '',
        'PM10': '',
        'SO2': '',
        'CO': ''
      }
      // 设置默认优良等级天数list
      let classification = Array.from({length: 12}, (el, i) => i + 1).map(el => {
        return {
          days: '',
          level: el
        }
      })
      let {gradeLevel} = this

      let arr = data.map(el => {
        el.classification = classification.map(item => {
          const data = el.classification.find(i => item.level === Number(i.level))
          if (data) {
            data.level = Number(data.level)
            data.levelName = gradeLevel[Number(data.level)]
            return data
          }
          item.levelName = gradeLevel[item.level]
          return item
        })

        let monthData = el.monthData.map(item => {
          item.classification = classification.map(month => {
            const data = item.classification.find(i => month.level === Number(i.level))
            if (data) {
              data.level = Number(data.level)
              data.levelName = gradeLevel[Number(data.level)]
              return data
            }
            month.levelName = gradeLevel[month.level]
            return month
          })

          return {...routine, ...item}
        })

        return {...routine, ...el, monthData: monthData}
      })

      this.formatData(arr)
    },
    formatData (data) {
      let month = Array.from({length: 12}, (el, i) => i + 1)
      let setTableData = data.map(el => {
        // 计算 年优良天数、污染天数总和
        let goodDays = el.classification.reduce((pre, item) => {
          if (item.level < 3 && item.days !== '') {
            pre += Number(item.days)
          }
          return pre
        }, 0)

        let badDays = el.classification.reduce((pre, item) => {
          if (item.level > 2 && item.days !== '') {
            pre += Number(item.days)
          }
          return pre
        }, 0)

        let monthData = month.map(item => {
          let date = new Date(el.date, item - 1, 1).format('YYYY-MM')
          let month = el.monthData.find(data => data.date === date)
          if (month) {
            return month
          }

          return this.defaultMonthData(date, el.siteId)
        }).sort((x, y) => new Date(x.date) - new Date(y.date))

        return {...el, goodDays, badDays, monthData: monthData}
      })

      let computedGoodMonthData = setTableData.map(el => {
        let monthData = el.monthData.map(data => {
          // 计算月优良天数、污染天数总和
          let goodDays = data.classification.reduce((pre, item) => {
            if (item.level < 3 && item.days !== '') {
              pre += Number(item.days)
            }
            return pre
          }, 0)

          let badDays = data.classification.reduce((pre, item) => {
            if (item.level > 2 && item.days !== '') {
              pre += Number(item.days)
            }
            return pre
          }, 0)

          return {...data, goodDays, badDays}
        })

        return {...el, monthData: monthData}
      })

      this.list = Object.freeze(computedGoodMonthData)
      this.computedPV()
    },
    computedPV () {
      let {reference, pvVal, list} = this
      let nullVal = Array.from({length: 12}, () => '')

      // 今年有几天
      let fullYearDays = nullVal.reduce((pre, el, i) => {
        let days = new Date(new Date().format('YYYY'), i + 1, 0).getDate()
        pre += Number(days)

        return pre
      }, 0)

      // 目标值超出今年最大天数
      if (pvVal > fullYearDays) {
        this.$message({
          message: `超出最长天数（${fullYearDays}天）`,
          type: 'warning'
        })
        this.pvVal = 200
        pvVal = 200
      }
      // 没有参考年份
      if (reference.length === 0) {
        this.pvData = nullVal
        return
      }
      // 筛选出所以参考年费的数据
      let data = list.filter(el => reference.includes(Number(el.date)))
      let targetPVData = this.getTargetPVData(data, pvVal).reduce((map, el, i) => {
        let currentMonthDays = new Date(new Date().format('YYYY'), i + 1, 0).getDate()
        if (!map['target']) {
          map['target'] = {
            sort: '年度达标预测'
          }
        }

        map['target'][i + 'data'] = el
        map['target'][i + 'flag'] = el > currentMonthDays ? '#FF0000' : '#FF7E00'

        return map
      }, {})
      let livePVData = this.getLivePVData(data, list, pvVal).reduce((map, el, i) => {
        let currentMonthDays = new Date(new Date().format('YYYY'), i + 1, 0).getDate()
        if (!map['live']) {
          map['live'] = {
            sort: '当前达标预测'
          }
        }

        map['live'][i + 'data'] = el
        map['live'][i + 'flag'] = el > currentMonthDays ? '#FF0000' : '#FF7E00'

        return map
      }, {})

      let pvData = Object.values(targetPVData).concat(Object.values(livePVData))
      // .map((el, i) => {
      //   let currentMonthDays = new Date(new Date().format('YYYY'), i, 0).getDate()
      //   return {
      //     targetVal: el,
      //     liveVal: livePVData[i],
      //     targetFlag: el > currentMonthDays ? 'red' : 'green',
      //     liveFlag: livePVData[i] > currentMonthDays ? 'red' : 'green'
      //   }
      // })
      // console.log(pvData)
      this.pvData = pvData
    },
    getTargetPVData (data, pvVal) {
      // 默认设置预测12个月数据为0
      let defaultData = Object.fromEntries(Array.from({length: 12}, (el, i) => [i + 1, 0]))
      // 获取参考年份 优良天数总数
      let yearGoodDays = data.reduce((pre, item) => {
        if (item.goodDays !== '') {
          pre += Number(item.goodDays)
        }
        return pre
      }, 0)

      // 获取 参考年份 按月统计的优良天数总数
      let pvData = data.map(el => {
        return el.monthData.map(item => Number(item.goodDays))
      })

      pvData.forEach(item => {
        item.forEach((el, i) => {
          defaultData[i + 1] += el
        })
      })

      /**
       * 年度按月预测 计算方法
       * if 按月统计的优良天数总数为0 或 年度优良天数为0  则 无法预测 即预测目标达标天数为0
       * else (按月统计的优良天数总数 / yearGoodDays) * 目标天数
      */
      let ratio = {}
      for (let key in defaultData) {
        if (defaultData[key] === 0 || yearGoodDays === '') {
          ratio[key] = 0
        } else {
          ratio[key] = Math.round(defaultData[key] / yearGoodDays * pvVal)
        }
      }

      return Object.values(ratio)
    },
    getLivePVData (data, list, pvVal) {
      // 获取当前月份
      let currentMonth = new Date().getMonth() + 1
      // 1
      let tempDefault = []
      // 获取参考年份数据 所有大于等于当前月份的优良天数
      let beforeYearData = data.map(el => {
        let temp = []
        el.monthData.forEach(item => {
          if (new Date(item.date).getMonth() + 1 >= currentMonth) {
            tempDefault.push(0)
            temp.push(Number(item.goodDays))
          }
        })
        return temp
      })
      // 获取参考年份数据 所有大于等于当前月份的优良天数总和
      let beforeYearDataSum = beforeYearData.flat().reduce((pre, days) => {
        if (days !== '') {
          pre += Number(days)
        }
        return pre
      }, 0)

      // 获取当前年数据
      let currentYearData = list.filter(el => el.date === Number(new Date().format('YYYY')))[0]
      let pvData = []
      // 获取当年 已有完整的月度优良天数
      let currentYearMonthData = currentYearData.monthData.map(el => {
        if (new Date(el.date).getMonth() + 1 < currentMonth) {
          return Number(el.goodDays)
        } else {
          pvData.push(0)
        }
      }).filter(el => Number.isFinite(el))

      // 获取当年 已有完整的月度优良天数总计
      let currentYearMonthDataSum = currentYearMonthData.reduce((pre, days) => {
        if (days !== '') {
          pre += Number(days)
        }
        return pre
      }, 0)

      /**
       * 目标优良天数 - 当年月度优良天数总和
       * 小于等于0 则当年空气质量已达标 后续月份无需有目标优良天数
       * 大于 则 计算剩余目标优良天数在以后的数月中 以参考年份的数据的比例算出 以后数月中分别占几天目标天数
       * 计算方法为（以当年20222年 月份7月,参考年份：2021，2020为例）
       * let julyTotal = 2021年7月优良天数 + 2020年7月优良天数
       * let historyTotal = 2021 7月-12月优良天数 + 2020 7月-12月优良天数
       * let 2022年7月目标优良天数 = 剩余目标值 * （julyTotal / historyTotal）结果四舍五入
      */

      /**
        else if (pvVal - currentYearMonthDataSum < beforeYearData[0].length) {
          let ratio = [pvVal - currentYearMonthDataSum]
          for (let i = 1; i < beforeYearData[0].length; i++) {
            ratio.push(0)
          }
          this.pvData = currentYearMonthData.concat(ratio)
        }
      */
      if (pvVal - currentYearMonthDataSum <= 0) {
        return currentYearMonthData.concat(pvData)
      } else {
        let day = pvVal - currentYearMonthDataSum
        beforeYearData.forEach(item => {
          item.forEach((el, i) => {
            tempDefault[i] += el
          })
        })

        let ratio = tempDefault.map(el => {
          if (el === 0 || beforeYearDataSum === '') {
            return 0
          } else {
            return Math.round(el / beforeYearDataSum * day)
          }
        })

        return currentYearMonthData.concat(ratio)
      }
    },
    defaultYearData (years, siteId) {
      return years.map(el => {
        return {
          date: el,
          NO2: '',
          avgAqi: '--',
          O3: '',
          monthData: [],
          primaryPollutantDays: [],
          SO2: '',
          siteId: siteId,
          maxAqi: '--',
          classification: [],
          minAqi: '--'
        }
      })
    },
    defaultMonthData (date, siteId) {
      return {
        date: date,
        NO2: '',
        O3: '',
        'PM2.5': '',
        PM10: '',
        SO2: '',
        CO: '',
        avgAqi: '--',
        primaryPollutantDays: [],
        siteId: siteId,
        maxAqi: '--',
        classification: [{
          days: '',
          level: 1,
          levelName: '优'
        }, {
          days: '',
          level: 2,
          levelName: '良'
        }, {
          days: '',
          level: 3,
          levelName: '轻度污染'
        }, {
          days: '',
          level: 4,
          levelName: '中度污染'
        }, {
          days: '',
          level: 5,
          levelName: '重度污染'
        }, {
          days: '',
          level: 6,
          levelName: '严重污染'
        }],
        minAqi: ''
      }
    }
  },
  created () {
    delete this.query.beginTime
    delete this.query.endTime
    delete this.query.dataType
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  &.has-header {
    grid-template-rows: 250px auto !important;
    grid-row-gap: 5px;

    /deep/ .data-wrapper-header {
      height: 250px !important;
      flex-wrap: wrap;

      h4 {
        width: 850px;
        margin: 0 auto;
        text-align: left;
      }
    }

    /deep/ .data-wrapper-body {
      gap: 10px;
    }
  }
}
.primary-pollutant {
  width: 230px;
  color: #000;

  h3 {
    margin: 0  0 5px 0;
    text-align: center;
  }
  p {
    margin: 3px 0;
  }

  .pollutant {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    border: 1px dashed RGBA(224, 218, 216, .9);

    > p{
      width: 49%;
      text-align: center;
      font-size: 16px;
      font-weight: bold;

      span {
        color: #54c9e8;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }

  .aqi-val {
    margin-top: 5px;
    text-align: center;

    > p{
      font-size: 16px;
      font-weight: bold;

      span {
        color: #54c9e8;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
}
.legend-wrapper {
  width: 850px;
  font-size: 13px;
  display: flex;
  gap: 10px;
  margin: 0 auto;
  padding: 0;
  color: #303133;
  list-style: none;
  -webkit-font-smoothing: antialiased;

  > li {
    --legend-section-size: 10px;

    display: grid;
    grid-template-columns: var(--legend-section-size) max-content;
    grid-column-gap: 3px;
    align-items: center;

    > section {
      padding-top: 100%;
    }
  }
}
.el-descriptions /deep/ .el-descriptions__header {
  margin-bottom: 5px;
}
.report-data-table-header {
  display: grid;
  grid-template-columns: auto max-content;
  align-items: center;
  padding: 0 10px;
  background: linear-gradient(90deg, #fbc15a 0, #fff);
  color: #ffffff;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/10AirQualityAnalysis/index.vue